import { connect } from 'react-redux';
import { UpsellWidgetComponent } from '../../../../partials/upsell-widget';
import { cartItemToEditSelector, upsellWidgetDataForCurrentEditingItemSelector } from '../../../../../redux/cart/cart.selectors';
const mapStateToProps = (state, props) => {
  const currentItem = cartItemToEditSelector(state);
  const {
    newQuantity,
    newItemPrice,
    currentItemPrice,
    isWithinRange = false,
    showInWidget
  } = upsellWidgetDataForCurrentEditingItemSelector(state, {
    item: currentItem,
    quantity: props.quantity,
    blendedQuantity: props.blendedQuantity
  });
  return {
    isShown: showInWidget && isWithinRange,
    fromPricePerItem: currentItemPrice,
    toPricePerItem: newItemPrice,
    proposedQuantity: newQuantity,
    withCloseButton: false
  };
};
export const UpsellWidget = connect(mapStateToProps)(UpsellWidgetComponent);